import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from '../../../components/OldPressCard/styles/styles.module.scss';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const allTrailsDotComLink = (
  <Link href="/" target="_blank">
    AllTrails.com
  </Link>
);

const oneTreePlantedDotOrg = (
  <Link href="https://onetreeplanted.org/" target="_blank">
    onetreeplanted.org
  </Link>
);

const pressRelease: OldPressReleaseCard = {
  cardType: 'press-release',
  title: <FormattedMessage defaultMessage="AllTrails Engages Its Community to Plant 100,000 Trees for Earth Month" />,
  date: 'April 16, 2024',
  modalContent: (
    <>
      <Typography variant="heading400" component="h2">
        <FormattedMessage defaultMessage="AllTrails Engages Its Community to Plant 100,000 Trees for Earth Month" />
      </Typography>

      <Typography variant="paragraph100" className={styles.noLigatures}>
        <FormattedMessage defaultMessage="San Francisco (April 16, 2024) — AllTrails, the world's largest and most trusted outdoor platform, issued an invitation to its community of more than 60 million members at the start of April: log time outside using the app, and AllTrails would plant trees in honor of Earth Month. Members from across the globe participated, and AllTrails is now planting 100,000 trees as a result of the initiative." />
        <br />
        <FormattedMessage defaultMessage="AllTrails plants trees through its partnership with One Tree Planted, an environmental reforestation nonprofit that focuses on locations where tree planting can have long-lasting positive impact. The reforestation efforts help create healthier communities and ecosystems. In addition to the Earth Month initiative, AllTrails plants trees for every order from its US online Gear Shop, when members refer a friend to AllTrails+, on employee anniversaries, and to celebrate company milestones." />
        <br />
        <FormattedMessage defaultMessage="“We’re inspired to see AllTrails members combining their trail time with outdoor stewardship—this month and every month,” said Ron Schneidermann, Chief Executive Officer at AllTrails. “Loving the outdoors and caring for the environment go hand in hand. AllTrails exists to help people do both, and we’re thrilled to make this donation of 100,000 trees to our partners at One Tree Planted.”" />
        <br />
        <FormattedMessage defaultMessage="AllTrails has been planting trees with One Tree Planted since 2021. AllTrails is a 1% for the Planet member, contributing 1% of its annual revenue to environmental organizations. " />
        <br />
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="About AllTrails" />
        </Typography>
        <br className={styles.noMargin} />
        <FormattedMessage
          defaultMessage="AllTrails helps you find your way outside with detailed reviews and inspiration from a global community of trail-goers. Every day, AllTrails is inspired to help get more people outside so they can have healthy, authentic experiences and a deeper appreciation of the outdoors. AllTrails was awarded Apple’s 2023 iPhone App of the Year and a Google Play Best of 2023 honorable mention. Download AllTrails in the App Store or head to {allTrailsDotComLink} to learn more."
          values={{ allTrailsDotComLink }}
        />
        <br />
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="About One Tree Planted" />
        </Typography>
        <br className={styles.noMargin} />
        <FormattedMessage
          defaultMessage="One Tree Planted is a 501(c)(3) nonprofit that is on a mission to make it simple for anyone to help the environment by planting trees. Their projects span the globe and are done in partnership with local communities and environmental organizations to create an impact for nature, people, and wildlife. Learn more at {oneTreePlantedDotOrg}."
          values={{ oneTreePlantedDotOrg }}
        />
      </Typography>
    </>
  )
};

export default pressRelease;
